import { Shapes } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { contentRow } from '../layouts/rows'
import { lazyPage } from '@/lib/lazyPage'

const ContentPage = lazyPage(() => import('@/pages/Content'), 'ContentPage')
const ContentDetailsPage = lazyPage(() => import('@/pages/ContentDetails'), 'ContentDetailsPage')

export const contentModule: ModuleDefinition = {
  menuCounters: true,
  key: 'content',
  /* Content is multimedia now (text, Drops, image, video): the article icon stays only on the "Texto" type. */
  icon: Shapes,
  iconName: 'shapes',
  namespaces: ['content'],
  ready: true,
  /* F-198: the default is what the page always drew. */
  layouts: { fallback: 'feed', renders: ['feed', 'cards', 'list', 'compact'], toRow: contentRow },
  ListPage: ContentPage,
  renderDetail: ({ spaceData }) => <ContentDetailsPage spaceId={spaceData?.id} />,
  workflow: { spaceActions: ['content.post.create'] }
}
